import { useState } from "react";
import type { IncomeRecordListItem } from "../types";

export interface PromptState {
  title: string;
  text: string;
  variant?: "success" | "error" | "warning";
}

export function useIncomeModals() {
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [editModal, setEditModal] = useState<IncomeRecordListItem | null>(null);
  const [detailModal, setDetailModal] = useState<IncomeRecordListItem | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<number | null>(null);
  const [prompt, setPrompt] = useState<PromptState | null>(null);

  return {
    createModal,
    setCreateModal,
    editModal,
    setEditModal,
    detailModal,
    setDetailModal,
    confirmDelete,
    setConfirmDelete,
    prompt,
    setPrompt,
  };
}
